import { render, staticRenderFns } from "./riderWisePerformanceReport_KSA_new.vue?vue&type=template&id=c9f2063a&"
import script from "./riderWisePerformanceReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./riderWisePerformanceReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports